import { CardType } from '@generated-types';
import { isCreditCardType } from '@utils/card-type-utils';

const CONTEXT_PATH = '/kredittbank-kredittkort-betjening-web';

export const REST_BASE_URL = `${CONTEXT_PATH}/rest/resource/v3`;

export const KREDITTBANKEN_BASE_URL = `${CONTEXT_PATH}/rest/resource/v4`;

export const REST_BASE_URL_DEBIT_CARDS = `${REST_BASE_URL}/debit-cards`;

export const REST_BASE_URL_CREDIT_CARDS = `${REST_BASE_URL}/credit-cards`;

export const REST_CLICK2PAY_BASE_URL = `${REST_BASE_URL}/wallets/click2pay`;

export const REST_ELIGIBLE_CARDS = `${REST_BASE_URL}/wallets/eligible-cards`;

export const getTypeCardBasePath = (cardType: CardType) =>
    isCreditCardType(cardType) ? REST_BASE_URL_CREDIT_CARDS : REST_BASE_URL_DEBIT_CARDS;

export const getTypeCustomerBasePath = (cardType: CardType) =>
    isCreditCardType(cardType) ? `credit-customers` : `debit-customers`;

export const getTypeOrganisationBasePath = (cardType: CardType) =>
    isCreditCardType(cardType) ? `credit-organisations` : `debit-organisations`;
